require('./transfersAgendaMoreInfoRow.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');

// @ helpers
const { formatCurrency } = require('utilities/currencyHelper');
const { formatText } = require('core/i18n').i18n;
const { formatIbanString } = require('commonsUtilities/stringHelper');
const { getLastNChars } = require('utilities/stringHelper');
const transfersHelper = require('utilities/transfersHelper');

// @ constants
const { NONE_SEPA, HYPHEN } = require('constants/index');
const { getTranslatedCountry } = require('constants/countries');

// @ components
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ actions
const beneficiariesActions = require('actions/beneficiaries');


class TransfersAgendaMoreInfoRow extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const {
            immBeneficiary,
            requestBeneficiaryDetails,
        } = this.props;
        requestBeneficiaryDetails(immBeneficiary.get('id'));
    }

    buildDetailFooter() {
        const { immBeneficiary, immScreen } = this.props;
        const basePath = `/myprofile/transfers/agenda/${immBeneficiary.get('id')}/`;
        const editLink = `${basePath}editBeneficiary`;
        const removeLink = `${basePath}remove`;
        const footerClasses = classNames({ 'transfers-agenda-more-info-row__footer' : !immScreen.get('isMobile') });

        if (immBeneficiary.get('isFetchingDetails'))  return null;

        return (
            <footer className={footerClasses}>
                <span className="transfers-agenda-more-info-row__button">
                    <OKButton
                        id="lnk_transfersAgendaMoreInfoRow_edit"
                        modifier="task"
                        to={editLink}
                    >
                        <i className="icon-editar transfers-agenda-more-info-row__icon" />
                    </OKButton>
                </span>
                <span className="transfers-agenda-more-info-row__button">
                    <OKButton
                        id="lnk_transfersAgendaMoreInfoRow_remove"
                        modifier="task"
                        to={removeLink}
                    >
                        <i className="icon-eliminar transfers-agenda-more-info-row__icon" />
                    </OKButton>
                </span>
            </footer>
        );
    }

    addRow(rowsArray, titleKey, value){
        rowsArray.push(
            <OKTableRowDetailsItem
                title={formatText(titleKey)}
                value={value}
            />
        );
    }

    addBeneficiaryRow(rowsArray, paramAttr) {
        const { immBeneficiary } = this.props;
        return this.addRow(
            rowsArray,
            `beneficiaryAgendaDetail-${paramAttr}`,
            immBeneficiary.get(paramAttr) || HYPHEN
        );
    }

    buildAccountDetailsRows() {
        const { immBeneficiary, immScreen } = this.props;
        const isMobile = immScreen.get('isMobile');
        const sepaType = transfersHelper.getSepaTypeTransfers(immBeneficiary.get('country'), immBeneficiary.get('currency'), immBeneficiary.get('iban'));

        let rowsArray = [];
        if (sepaType === NONE_SEPA) {
            this.addRow(
                rowsArray,
                'beneficiaryAgendaDetail-account',
                immBeneficiary.get('accountNumber'),
                isMobile,
            );
        } else {
            this.addRow(
                rowsArray,
                'beneficiaryAgendaDetail-iban',
                formatIbanString(immBeneficiary.get('iban')),
                isMobile,
            );
        }
        return rowsArray;
    }

    buildAddressRows() {
        const { immBeneficiary } = this.props;
        const sepaType = transfersHelper.getSepaTypeTransfers(immBeneficiary.get('country'), immBeneficiary.get('currency'), immBeneficiary.get('iban'));

        let rowsArray = [];
        if (sepaType === NONE_SEPA) {
            this.addBeneficiaryRow(rowsArray, 'address');
            this.addBeneficiaryRow(rowsArray, 'city');
            if (immBeneficiary.get('bic')) {
                this.addBeneficiaryRow(rowsArray, 'bic');
            } else if (immBeneficiary.get('bankName')) {
                this.addBeneficiaryRow(rowsArray, 'bankName');
                this.addBeneficiaryRow(rowsArray, 'bankAddress');
                this.addBeneficiaryRow(rowsArray, 'bankCity');
            }
        }
        return rowsArray;
    }

    buildDesktopRows() {
        const { immBeneficiary } = this.props;
        const detailFooter = this.buildDetailFooter();

        let rowsArray = [];

        this.addBeneficiaryRow(rowsArray, 'name', false);

        rowsArray = [...rowsArray, ...this.buildAccountDetailsRows()];

        this.addRow(
            rowsArray,
            'beneficiaryAgendaDetail-country',
            getTranslatedCountry(immBeneficiary.get('country')),
            false,
        );

        rowsArray = [...rowsArray, ...this.buildAddressRows()];

        return (
            <OKTableRow>
                <OKTableCell />
                <OKTableCell colSpan={5} >
                    <OKTableRowDetails
                        title={formatText('beneficiaryAgendaDetail-title')}
                        columns={2}
                    >
                        {rowsArray}
                    </OKTableRowDetails>
                    {detailFooter}
                </OKTableCell>
                <OKTableCell />
            </OKTableRow>
        );
    }

    buildMobileRows() {
        const { immBeneficiary, immScreen } = this.props;
        const account = getLastNChars( immBeneficiary.get('iban') || immBeneficiary.get('accountNumber') );
        const currency = formatCurrency(immBeneficiary.get('currency'));
        const detailFooter = this.buildDetailFooter();

        let rowsArray = [];

        this.addRow(
            rowsArray,
            'transfersAgenda-accountColumnHeader',
            account,
            true,
        );

        this.addRow(
            rowsArray,
            'transfersAgenda-currencyColumnHeader',
            currency,
            true,
        );

        this.addBeneficiaryRow(rowsArray, 'name', true);

        this.addRow(
            rowsArray,
            'beneficiaryAgendaDetail-country',
            getTranslatedCountry(immBeneficiary.get('country')),
            true,
        );

        rowsArray = [...rowsArray, ...this.buildAccountDetailsRows(), ...this.buildAddressRows()];

        return (
            <OKTableRow>
                <OKTableCell />
                <OKTableCell colSpan={5} >
                    <OKTableRowDetails
                        columns={1}
                        isMobile={immScreen.get('isMobile')}
                    >
                        {rowsArray}
                    </OKTableRowDetails>
                    {detailFooter}
                </OKTableCell>
                <OKTableCell />
            </OKTableRow>
        );
    }

    render() {
        const { immScreen } = this.props;
        return immScreen.get('isMobile') ? this.buildMobileRows() : this.buildDesktopRows();
    }
}

TransfersAgendaMoreInfoRow.propTypes = {
    immScreen: PropTypes.object.isRequired,
    immBeneficiary: PropTypes.object.isRequired,
    requestBeneficiaryDetails: PropTypes.func
};

module.exports.constructor = TransfersAgendaMoreInfoRow;
module.exports.TransfersAgendaMoreInfoRow = connect(null, {
    requestBeneficiaryDetails: beneficiariesActions.requestBeneficiaryDetails
})(TransfersAgendaMoreInfoRow);
